const casinoInitialState = {
    casinoList: [],
    
};

export default casinoInitialState;
